!function () {
    class t extends HTMLElement {
        constructor() {
            super(), this.bindEvents = this.bindEvents.bind(this), this.userTyping = this.userTyping.bind(this), this.resetSearch = this.resetSearch.bind(this), this.focusInputSearch = this.focusInputSearch.bind(this), this.handleMobileNavOpener = this.handleMobileNavOpener.bind(this)
        }

        connectedCallback() {
            this.Search = this, this.isSearchDrawer = this.Search.hasAttribute("data-search-drawer"), this.initSearch()
        }

        initSearch() {
            this.searchInput = this.querySelector(".js-input-search"), this.searchInputReset = this.querySelector(".js-input-search-reset"), this.searchInputsClear = document.querySelectorAll(".js-input-search-clear"), this.searchClose = document.querySelector(".search-form__clear-button"), this.searchInputValue = this.searchInput.value, this.mobileBreakpoint = 1024, this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
            this.bindEvents()
        }

        bindEvents() {
            if (this.searchInput && this.searchInput.addEventListener("keyup", this.userTyping), this.searchInputsClear) for (let e = 0; e < this.searchInputsClear.length; e++) this.searchInputsClear[e].addEventListener("click", this.resetSearch);
            this.searchInputReset && this.searchInputReset.addEventListener("click", this.resetSearch), this.searchInput && this.searchInput.addEventListener("click", this.focusInputSearch), this.isSearchDrawer && (this.searchDrawer = document.querySelector("w3-drawer-search.drawer-search"), this.searchDrawer.addEventListener("drawer--open", () => this.focusInputSearch()), this.focusInputSearch()), !this.isSearchDrawer && this.isMobile && this.searchClose && this.searchClose.addEventListener("click", this.resetSearch)
        }

        handleMobileNavOpener() {
            this.searchDrawer.isDrawerOpen || setTimeout(() => {
                this.searchDrawer.openDrawer()
            }, 420)
        }

        focusInputSearch() {
            setTimeout(() => {
                this.searchInput.focus()
            }, 200), this.searchInput.focus()
        }

        resetSearch() {
            this.searchInput.value = "", this.searchInputValue = "", this.searchInput.blur(), window.history.replaceState(null, null, "?q="), this.focusInputSearch()
        }

        userTyping(e) {
            if ("Enter" !== e.key && 13 !== e.key) {
                let t = `?q=${this.searchInput.value}&type=product`;
                this.isSearchDrawer || window.history.replaceState(null, null, t)
            }
        }
    }

    customElements.define("w3-search", t)
}();